module.exports = __webpack_public_path__ + "static/media/22-3.7d273968.mp3";